import StringHelperService from 'services/string-helper.service';

export default {
  props: {
    legendPreset: {
      type: Array,
      required: false
    }
  },
  watch: {
    legendPreset: {
      deep: true,
      handler(preset) {
        if (!preset) return;

        this.turnOffAllLegendOptions();

        if (!preset.length) return;

        this.setLegendOptionVisibility(preset);
        this.toggleLegendOptionClass(preset);
      }
    }
  },
  methods: {
    createCustomLegendAndAddChartToData(chart) {
      const { customLegend } = this.$parent.$refs;

      this.chart = chart;
      this.createLegendGroups(customLegend);
      this.createLegendItems(chart, customLegend);
      this.addVisibilityToggleToLegendItems(chart, customLegend);
    },

    createLegendGroups(customLegend) {
      this.legendGroups.forEach(() => {
        const legendGroup = document.createElement('div');
        legendGroup.classList.add('group');
        customLegend.append(legendGroup);
      });
    },

    createLegendItems(chart, customLegend) {
      chart.series.forEach(({ color, name }) => {
        /* Find the array that contains an element in legendGroups, a 2-dimensional array */
        const index = this.legendGroups.findIndex(group => group.some(prop => prop === name));
        const title = this.graphProps.find(prop => prop.name === name)?.title || StringHelperService.fieldToTitle(name);
        const item = `<div class="item ${name}">
        <div class="symbol" style="background-color: ${color}"></div>
        <div class="series-name">${title}</div>
        </div>`;

        customLegend.getElementsByClassName('group')[index].insertAdjacentHTML('beforeend', item);
      });
    },

    addVisibilityToggleToLegendItems(chart, customLegend) {
      Array.from(customLegend.getElementsByClassName('item')).forEach((item, index) => {
        item.addEventListener('click', () => {
          const point = chart.series[index];

          point.setVisible(!point.visible);

          if (point.visible) {
            item.classList.remove('not-visible');
          } else {
            item.classList.add('not-visible');
          }

          this.$emit('customSelection');
        });
      });
    },

    turnOffAllLegendOptions() {
      this.chart.series.forEach(point => point.setVisible(false));
      Array.from(this.$parent.$refs.customLegend.getElementsByClassName('item')).forEach(item =>
        item.classList.add('not-visible')
      );
    },

    setLegendOptionVisibility(preset) {
      preset.forEach(prop => {
        this.chart.series.find(point => point.name === prop).setVisible(true);
      });
    },

    toggleLegendOptionClass(preset) {
      // Find the legend options that are in the preset array and toggle their class.
      Array.from(this.$parent.$refs.customLegend.getElementsByClassName('item')).forEach(item => {
        if (Array.from(item.classList.values()).some(value => preset.includes(value))) {
          item.classList.remove('not-visible');
        }
      });
    }
  }
};
